import { useMemo } from 'react';
import { Select } from 'antd';

import { useGetClientNamesQuery } from '../redux/api/clients';

interface ClientSelectProps {
    value?: number;
    onChange?: (value: number) => void;
}

const ClientSelect = ({ value, onChange }: ClientSelectProps) => {

    const { data, isFetching } = useGetClientNamesQuery(undefined);

    const options = useMemo(
        () => (data ?? []).map((c: any) => ({ value: c.id, label: c.name })),
        [data]
    );

    return (
        <Select
            showSearch
            value={value}
            options={options}
            loading={isFetching}
            optionFilterProp="label"
            placeholder="Search for a client by name"
            onChange={onChange}
        />
    );
};

export default ClientSelect;
